import { render, staticRenderFns } from "./CasesDecisionChart.vue?vue&type=template&id=1c6dd755&scoped=true"
import script from "./CasesDecisionChart.vue?vue&type=script&lang=js"
export * from "./CasesDecisionChart.vue?vue&type=script&lang=js"
import style0 from "./CasesDecisionChart.vue?vue&type=style&index=0&id=1c6dd755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6dd755",
  null
  
)

export default component.exports